export default function Footer() {
  const handleNavigation = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/8335385e15f4d3c6bfe86bf615acf614/3903045b59a8f5714de3a5b567395dd5.png" 
              alt="Everstead Logo" 
              className="h-10 mb-4"
            />
            <p className="text-gray-400 leading-relaxed">
              Bringing calm, clarity, and modern operations to senior living communities.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => handleNavigation('/about')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/pricing')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/faq')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  FAQ
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/contact')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">Operations Audit</li>
              <li className="text-gray-400">Workflow Automation</li>
              <li className="text-gray-400">Documentation Support</li>
              <li className="text-gray-400">Staff Training</li>
              <li className="text-gray-400">Ongoing Partnership</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Resources</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => handleNavigation('/resources')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Resource Hub
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/client-portal')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Client Portal
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; 2024 Everstead. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
